const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
import WithSiteMaintenanceMode from '../DataHOCs/WithSiteMaintenanceMode';
import WithShortCourseDoc from '../DataHOCs/WithShortCourseDoc';
import WithChannelActivities from '../DataHOCs/WithChannelActivities';
import WithChannelProjects from '../DataHOCs/WithChannelProjects';
const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');
const TemplateStore = require('../../stores/template_store_reflux');
import ShortCoursePlayStore from '../../stores/ShortCoursePlayStore';
const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');

import ShortCoursePlay from './play/ShortCoursePlay';

const FLOW_FOCI = ShortCoursePlayStore.FLOW_FOCI;

const _ = {
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    forEach:    require('lodash/forEach'),
    isObject:   require('lodash/isObject'),
};

const propTypes = {
	shortCourse: PropTypes.object.isRequired,
	doc: PropTypes.object.isRequired,
    projectStoreState: PropTypes.shape({ initialized: PropTypes.bool, projects: PropTypes.array }).isRequired,
    activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.object }).isRequired,
};
const defaultProps = {};

export class PreviewShortCourseViewComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalState: {},
        };
    }
    
    onClose=()=>{
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}`);
    }

    render() {
        return (
            <PreviewShortCourse {...this.props} askToExitCourse={this.onClose} />
        );
    }
}

export class PreviewShortCourse extends React.Component {
    constructor(props) {
        super(props);
        let { activities, templates, pendingMetaData } = this.buildActivityAndTemplateData(props.doc);

        let channelId = Number(props.channelId);
        let shortCourseId = props.shortCourseId;
        if (!shortCourseId) {
            if (props.match) {
                shortCourseId = props.match.params.shortCourseId;
            }
            else {
                console.log("PreviewShortCourse unable to determine shortCourseId");
            }
        }
        this.playStore = new ShortCoursePlayStore({
            doc: {...props.doc, activity_types: props.shortCourse.activity_types, course_title: props.shortCourse.title }, // put activity_types in the doc (to match instance doc structure)
            user: { id: 'preview_user', hash: "preview_hash", first_name: "Student", last_name: "Previewer" },
            activities,
            templates,
            preview: true,
            channelId,
            shortCourseId,
        });
        this.state = {
            activities,
            pendingMetaData,
            modalState: {},
        };
        // this.iframe = React.createRef();
        this.unsubscribes = [ ActivityStore.listen(this.onActivityStoreChange) ];
    }

    componentDidMount() {
        this.playStore.startPlay();
        window.addEventListener('message',this.listenForPreviewScore);
    }
    
    componentWillUnmount() {
        window.removeEventListener('message',this.listenForPreviewScore);
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes; // allows this to be a test for the component having gone away 
    }
    
    onActivityStoreChange = (storeState) => {
        if (storeState.action) {
            const index = _.findIndex(this.state.pendingMetaData, { actionId: storeState.action.id });
            const entry = this.state.pendingMetaData[index];
            if (entry) {
                // console.log(`got meta_data for activityId ${entry.activityId}`);
                let pendingMetaData = this.state.pendingMetaData.slice();
                pendingMetaData.splice(index, 1);
                let activities = this.state.activities.slice();
                let act_i = _.findIndex(activities,{id: entry.activityId});
                let activity = activities[act_i];
                if (activity) {
                    let store_activity;
                    _.forEach(storeState.activities,(projActivities,proj_id)=>{
                        store_activity = _.find(projActivities, { activity_id: activity.activity_id });
                        if (store_activity) {
                            return false;
                        }
                    });
                    if (store_activity) {
                        activity.meta_data = store_activity.meta_data; // <--------- this is what we want to accomplish (don't really need state otherwise)
                        activities[act_i] = {...activity}; // shallow clone so react knows object changed
                        // console.log(`new meta_data for activity ${activity.id}: ${JSON.stringify(activity.meta_data)}`);
                    }
                }
                // tell the store about the new activities if we got all the meta data
                if (!pendingMetaData.length) {
                    this.playStore.updateActivities(activities);
                }
                this.setState({pendingMetaData,activities});
            }
        }
    }

    // build the activity and template data that we need to preview/play a short course
    buildActivityAndTemplateData = (doc) => {
        //const storeProjects = (this.props.projectStoreState && this.props.projectStoreState.initialized && this.props.projectStoreState.projects) || [];
        const storeActivities = (this.props.activityStoreState && this.props.activityStoreState.initialized && this.props.activityStoreState.activities) || {}; // keyed by project

        let activities = [];
        let need_full_info_ids = [];
        _.forEach(doc.content_blocks,(cb)=>{
            if (cb.type === Globals.short_course.content_block_type.ACTIVITY) {
                let exists = _.find(activities,{activity_id: cb.nova_activity_id});
                if (!exists) {
                    let activity;
                    _.forEach(storeActivities,(projActivities,proj_id)=>{
                        activity = _.find(projActivities, { activity_id: cb.nova_activity_id });
                        if (activity) {
                            return false;
                        }
                    });
                    if (activity) {
                        activities.push({
                            id: activity.id,
                            meta_data: activity.meta_data,
                            activity_id: activity.activity_id,
                            template_id: activity.template_id,
                            title: activity.title,
                            short_course_meta_data: activity.short_course_meta_data,
                        });
                        if (!activity.meta_data || !activity.meta_data.saveDate || (typeof activity.title === 'undefined')) { // If there's not a saveDate, we don't have the full meta_data
                            // console.log("need more meta data for activity:",activity.id, activity.title, activity.activity_id);
                            need_full_info_ids.push(activity.id);
                        }
                    }
                    else {
                        console.log(`did not find ${cb.nova_activity_id} for content block ${cb.hash}`);
                    }
                }
            }
        }); // for content blocks
        
        // massage templates into an object keyed by template_id
        const global_template_array = TemplateStore.getState().globalTemplates;
        const template_array = TemplateStore.getState().templates;
        let templates = {};
        if (global_template_array.length) {
            _.forEach(global_template_array,(elem)=>{
                templates[elem.id] = {
                    name: elem.name,
                    template_url: elem.template_url
                }
            });
        }
        else {
            _.forEach(template_array,(elem)=>{
                templates[elem.id] = {
                    name: elem.name,
                    template_url: elem.template_url
                }
            });
        }
        
        
        let pendingMetaData = [];
        // console.log(`requesting full info for ${need_full_info_ids.length} activities`);
        _.forEach(need_full_info_ids,(activityId)=>{
            let actionId = uuid.v4();
            ActivityActions.getActivity(actionId, {activityId});
            pendingMetaData.push({actionId,activityId});
        });
        
        return { activities, templates, pendingMetaData };
    } // buildActivityAndTemplateData
    
    listenForPreviewScore = (evt) =>{
        if (!evt || !evt.data) {
            return; // ignore anything that doesn't match what we're listening for
        }
        var msg = evt.data;
        // var origin = evt.origin;
        if (_.isObject(msg)) {
            switch(msg.type) {
                case 'preview-scores': {
                    let flowFocus = this.playStore.getFlowFocus(); 
                    if (flowFocus === FLOW_FOCI.ActivityAttempt) {
                        let hash = this.playStore.getCurrentContentBlockHash();
                        this.playStore.actions.addContentBlockAttempt({hash, scoreData: msg.scoreData});
                        // Stay at the score panel for a bit and then show the next screen
                        setTimeout(()=>{
                            if (this.unsubscribes) { // if not unmounted
                                this.playStore.actions.goToPostAttemptScreen();
                            }
                        }, 1000);
                    }
                    else {
                        console.log(`got preview scores but flowFocus is ${flowFocus}`);
                    }
                    break;
                }
                // we don't care about any other messages
            }
        }
    }

    render() {
        let loading = this.state.pendingMetaData && this.state.pendingMetaData.length;
        return (
            <div className="short-course-preview">
                <ShortCoursePlay playStore={this.playStore} askToExitCourse={this.props.askToExitCourse} onClose={this.props.askToExitCourse} loading={loading}/>
            </div>
        );
    }

}

PreviewShortCourse.propTypes = {
    channelId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    shortCourseId: PropTypes.string.isRequired,
    shortCourse: PropTypes.object.isRequired,
    doc: PropTypes.object.isRequired,
    projectStoreState: PropTypes.shape({ initialized: PropTypes.bool, projects: PropTypes.array }).isRequired,
    activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.object }).isRequired,
    askToExitCourse: PropTypes.func, 
};

PreviewShortCourse.defaultProps = {
};

PreviewShortCourseViewComponent.propTypes = propTypes;
PreviewShortCourseViewComponent.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithSiteMaintenanceMode(WithShortCourseDoc(WithChannelProjects(WithChannelActivities(PreviewShortCourseViewComponent)))));

function PreviewShortCourseView(props) {
    return (
        <WrappedComponent
            {...props}
            shortCourseId={props.match.params.shortCourseId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
        />
    );
}

PreviewShortCourseView.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            shortCourseId: PropTypes.string.isRequired,
            shortCourseVersion: PropTypes.string, // TODO NOTE: this is ignored
        }).isRequired,
    }).isRequired,
};

export default PreviewShortCourseView;